import { Component, Input } from '@angular/core';
import { GridProps, gridStyles } from '@kite_aerolab/shared/components';

@Component({
  selector: 'kite-grid',
  template: '<div [ngClass]="gridStyles"><ng-content></ng-content></div>',
})
export class GridComponent {
  /**
   * Css del componente
   */
  @Input() css: GridProps['css'];
  /**
   * Columnas
   */
  @Input() cols: GridProps['cols'];
  /**
   * Columnas
   */
  @Input() rows: GridProps['rows'];

  /**
   * Espaciado entre componentes
   */
  _spacing: GridProps['spacing'];

  @Input() get spacing() {
    return this._spacing;
  }

  set spacing(value: GridProps['spacing']) {
    this._spacing = value;
  }

  public get gridStyles(): string[] {
    return [
      gridStyles({
        css: this.css,
        spacing: this.spacing,
        cols: this.cols,
        rows: this.rows,
      }).className,
    ];
  }
}
